import React from "react";
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonIcon, IonFooter
} from "@ionic/react";
import {
    arrowBack
} from "ionicons/icons";
import useStore from "../zustand/useStore";
import JobUserProfileDetailComponent from "./JobUserProfileDetailComponent";

const JobMembersToApplyComponents = ({ isOpen }) => {
    const {setIsOpenCandidatesDeservingModel,setDeservingCandidatesProfileData,deservingCandidatesProfileData} = useStore();

    const onClose = ()=>{
        setIsOpenCandidatesDeservingModel(false);
        setDeservingCandidatesProfileData({});
    }

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onClose}
            initialBreakpoint={1}
            breakpoints={[0, 0.6, 0.9, 1]}
            backdropDismiss={true}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onClose}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Candidate Profile</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <JobUserProfileDetailComponent deservingCandidatesProfileData={deservingCandidatesProfileData}/>
            </IonContent>
            <IonFooter className="blank_footer_bar">
                <IonToolbar>

                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
};

export default JobMembersToApplyComponents;
